export default __webpack_public_path__ + "static/media/fireWall.b71bc2e8.svg";